import React, { useState, useEffect } from "react";
import { TextField, Button, Grid, Paper, Typography, Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import "./login.scss";

import {
  setUserId,
  setUserEmail,
  setClubName,
  setAdminType,
} from "../../../reduxtool/userSlice";
import { useDispatch } from "react-redux";

const Login = () => {
  const dispatch = useDispatch();
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [emailError, setEmailError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const script = document.createElement("script");
    script.src =
      "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js";
    script.async = true;
    document.body.appendChild(script);
  }, []);

  const validateEmail = (value) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!value) return "Email is required.";
    if (!emailRegex.test(value)) return "Please enter a valid email address.";
    return "";
  };

  const validatePassword = (value) => {
    if (!value) return "Password is required.";
    return "";
  };

  const handleLogin = async () => {
    const emailValidationError = validateEmail(email);
    const passwordValidationError = validatePassword(password);

    setEmailError(emailValidationError);
    setPasswordError(passwordValidationError);

    if (emailValidationError || passwordValidationError) return;

    setLoading(true);

    try {
      const response = await fetch(BASE_URL + "/api/users/loginAdminUser", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });

      const data = await response.json();
      if (response.ok) {
        // Essential: Saving to Redux makes this available to Sidebar on ALL pages
        dispatch(setUserId(data.globalUser._id));
        dispatch(setUserEmail(data.globalUser.email));
        dispatch(setAdminType(data.globalUser.adminType));
        dispatch(setClubName(data.globalUser.clubName));

        navigate("/dashboard"); // Simply navigate; Sidebar will pull from Redux
      } else {
        setPasswordError(data.message || "Invalid email or password.");
      }
    } catch {
      setPasswordError("An error occurred while connecting to the server.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Grid
      container
      component="main"
      sx={{ height: "100vh", backgroundColor: "#1976d2" }}
      alignItems="center"
      justifyContent="center"
    >
      {/* Login Box */}
      <Grid
        item
        xs={12}
        sm={8}
        md={5}
        component={Paper}
        elevation={12}
        square
        sx={{
          borderRadius: 4,
          position: "relative",
        }}
      >
        {/* CONTACT US BUTTON */}
        <Button
          onClick={() =>
            window.open("https://www.merogaunonline.org/contactinfo", "_blank")
          }
          sx={{
            position: "absolute",
            top: 16,
            right: 16,
            background: "linear-gradient(135deg, #42a5f5, #1976d2)",
            color: "#fff",
            borderRadius: "30px",
            padding: "6px 18px",
            fontSize: "0.75rem",
            fontWeight: 600,
            textTransform: "none",
            boxShadow: "0 6px 16px rgba(0,0,0,0.25)",
            "&:hover": {
              background: "linear-gradient(135deg, #1976d2, #0d47a1)",
              transform: "translateY(-1px)",
            },
          }}
        >
          Contact Us
        </Button>

        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            padding: 4,
          }}
        >
          <img
            src="/img/logo.png"
            alt="Logo"
            style={{ width: "150px", borderRadius: "10%" }}
          />

          <TextField
            margin="normal"
            fullWidth
            label="Email Address"
            type="email"
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
              setEmailError(validateEmail(e.target.value));
            }}
            error={!!emailError}
            helperText={emailError}
            sx={{ "& .MuiOutlinedInput-root": { borderRadius: 3 } }}
            required
          />

          <TextField
            margin="normal"
            fullWidth
            label="Password"
            type="password"
            value={password}
            onChange={(e) => {
              setPassword(e.target.value);
              setPasswordError(validatePassword(e.target.value));
            }}
            error={!!passwordError}
            helperText={passwordError}
            sx={{ "& .MuiOutlinedInput-root": { borderRadius: 3 } }}
            required
            autoComplete="off"
            onKeyDown={(e) => e.key === "Enter" && handleLogin()}
          />

          <Button
            variant="contained"
            sx={{
              mt: 2,
              borderRadius: "25px",
              padding: "10px 30px",
            }}
            onClick={handleLogin}
            disabled={loading}
          >
            {loading ? "Signing In..." : "Sign In"}
          </Button>

          <Typography variant="body2" color="text.secondary" sx={{ mt: 3 }}>
            Dreamsoft Technology
          </Typography>

          <Typography
            variant="body2"
            sx={{ fontSize: "0.75rem", color: "#000" }}
          >
            javalok2011@gmail.com
          </Typography>
        </Box>
      </Grid>
    </Grid>
  );
};

export default Login;
